import React from 'react';
import './Features.css';

const Features = () => {
  return (
    <section id="features">
      <h2 className="features-section-title">Our Key Features</h2>
      <div className="features">
        <div className="feature-card">
          <i className="fas fa-bell"></i>
          <h3>Real-Time Stock Alerts</h3>
          <h5>🔔 <a href="/AlartSetFormFixedPrice">Set Alerm</a></h5>
          <p>Get instant notifications for significant stock movements.</p>
        </div>

        <div className="feature-card">
          <i className="fas fa-chart-line"></i>
          <h3>In-Depth Analysis</h3>
          <h5>📊 <a href="/analysis">Stock Analysis</a></h5>
          <p>Advanced analytics and reports on your favorite stocks.</p>
        </div>



<div className="feature-card">
  <i className="fas fa-chart-candlestick"></i>
  <h3>Technical Indicators</h3>
  <h5>📈 <a href="/technical-analysis-dashboard">Technical Analysis</a></h5>
  <p>Real-time charts, moving averages, and automated BUY/SELL trading signals.</p>
</div>





        <div className="feature-card">
          <i className="fas fa-users"></i>
          <h3>Personalized Recommendations</h3>
          <p>Tailored stock suggestions based on your preferences.</p>
        </div>

        <div className="feature-card">
          <i className="fas fa-wallet"></i>
          <h3>Portfolio Tracking</h3>
          <p>Monitor your portfolio and track performance over time.</p>
        </div>
      </div>
    </section>
  );
};

export default Features;
